const ConcretePumpingHero = () => {
  return (
    <section className="relative min-h-[70vh] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/4431b0440222dc2ea6b9166f886486b6.jpg"
          alt="Concrete Pumping Services"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 text-center">
        <div className="inline-block bg-yellow-500 text-black px-6 py-2 rounded-full font-bold text-sm mb-6">
          SPECIALIZED SERVICE
        </div>
        
        <h1 className="text-6xl md:text-7xl font-bold text-white mb-6">
          Concrete Pumping
        </h1>
        
        <p className="text-xl md:text-2xl text-white/90 max-w-3xl mx-auto mb-10 leading-relaxed">
          Professional concrete pumping services for residential and commercial projects. 
          Efficient, precise, and reliable delivery for any job size.
        </p>

        <div className="flex flex-wrap gap-4 justify-center">
          <a
            href="/schedule"
            className="bg-yellow-500 text-black px-10 py-4 rounded-lg font-bold text-lg hover:bg-yellow-400 transition-all cursor-pointer whitespace-nowrap"
          >
            SCHEDULE SERVICE
          </a>
          <a
            href="#quote-form"
            className="bg-white/10 backdrop-blur-sm text-white border-2 border-white px-10 py-4 rounded-lg font-bold text-lg hover:bg-white/20 transition-all cursor-pointer whitespace-nowrap"
          >
            GET A QUOTE
          </a>
        </div>
      </div>
    </section>
  );
};

export default ConcretePumpingHero;